import React from "react";
import { useNavigate } from "react-router-dom";
import Corners from "../ui/Corners";
import { ArrowLeft } from "../ui/Icons";
import { useSeo } from "../../lib/seo";
import "../pages/Page.css";

export default function ErrorPage() {
  const navigate = useNavigate();
  useSeo({ title: "Page not found | Episcope AI", path: "/404", noindex: true });
  return (
    <div className="err">
      <div className="err__box">
        <Corners />
        <span className="err__label mono">object not found · conf 0.00</span>
        <span className="err__code">404</span>
        <h1 className="h2">Nothing detected at this address.</h1>
        <p className="lead" style={{ textAlign: "center" }}>
          The page you are looking for does not exist or has been moved.
        </p>
        <button type="button" className="btn btn-primary" onClick={() => navigate("/")}>
          <ArrowLeft className="i" /> Back to home
        </button>
      </div>
    </div>
  );
}
